import React, { useState } from 'react'
import { css } from '@emotion/css'
import { Modal, Table, Input } from '@mantine/core'
import { Tooltip } from '@ow/comps'
import { IconMaps } from '@ow/icons'

const Tips = ({ label }) => {
  return (
    <Tooltip
      position="top"
      on={['hover']}
      trigger={
        <div>
          <IconMaps type="questionIcon" width={18} height={18} />
        </div>
      }
    >
      {label}
    </Tooltip>
  )
}

const SelectsDetail = ({ watch, children }) => {
  const [opened, setOpened] = useState(false)
  const getFixedNumber = (n) => {
    if (!n || Number.isNaN(Number(n))) return undefined
    return Number(n).toFixed(2)
  }

  return (
    <div id="select-editor-container">
      <div onClick={() => setOpened(true)}>{children}</div>
      <Modal
        centered
        target="#select-editor-container"
        opened={opened}
        size={640}
        onClose={() => setOpened(false)}
        title="更多设置"
      >
        <Table>
          <thead>
            <tr>
              <th>选项</th>
              <th>
                <div className="flex gap-2 relative">
                  <span>选中赋分值</span>
                  <Tips label="已赋分值将在导出问题大表和统计分析时使用" />
                </div>
              </th>
              <th>
                <div className="flex gap-2 relative">
                  <span>未选赋分值</span>
                  <Tips label="已赋分值将在导出问题大表时使用" />
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {watch('selects', []).map((item) => (
              <tr>
                <td>{item.title}</td>
                <td>
                  <Input
                    className={css`
                      width: 200px;
                    `}
                    defaultValue={item.selectedMark}
                    placeholder="赋分值 支持两位小数"
                    onChange={(e) => {
                      item.selectedMark = getFixedNumber(e.target.value)
                    }}
                  />
                </td>
                <td>
                  <Input
                    className={css`
                      width: 200px;
                    `}
                    defaultValue={item.unselectedMark}
                    placeholder="赋分值 支持两位小数"
                    onChange={(e) => {
                      item.unselectedMark = getFixedNumber(e.target.value)
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal>
    </div>
  )
}

export default SelectsDetail
